import { Component, OnInit } from '@angular/core';
import { CadastroContratoDto, CadastroDocumentoTipo } from '@usucampeao/lib-reurb-simplificado';
import { LoadingService, NavigationService, ToastService } from '@usucampeao/ui-mobile';

import { ActivatedRoute, Router } from '@angular/router';
import { filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { CadastroDocumentosUpload } from '../../../../shared/components/cadastros-documentos-upload/cadastros-documentos-upload.component';
import { CadastroService } from '../../state/cadastros.service';

@Component({
  templateUrl: './outros-documentos-upload.page.html',
  styleUrls: ['./outros-documentos-upload.page.scss']
})
export class OutrosDocumentosUploadPage extends CadastroDocumentosUpload implements OnInit {
  public dadosContrato: CadastroContratoDto;

  constructor(
    protected readonly cadastroService: CadastroService,
    protected readonly loadingService: LoadingService,
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly toastService: ToastService,
    private readonly navigationService: NavigationService,
  ) {
    super(
      cadastroService,
      loadingService,
      route,
      router,
      toastService,
    );
  }

  ngOnInit(): void {
    this.carregarDadosDaRota()
      .pipe(
        filter(() => this.tipo === CadastroDocumentoTipo.PROCURACAO),
        switchMap(() => this.cadastroService.buscarContrato(this.cadastroId)),
        tap(dadosContrato => this.dadosContrato = dadosContrato),
        takeUntil(this.ngUnsubscribe$),
      )
      .subscribe();
  }

  protected navegarParaProxima(): void {
    this.navigationService.voltar();
  }
}
